import { AABB } from './AABB.js';
import { BlockId, isPassable } from '../world/BlockType.js';

const EPSILON = 0.001;

export function moveWithCollision(world, aabb, velocity, dt) {
  let dx = velocity.x * dt;
  let dy = velocity.y * dt;
  let dz = velocity.z * dt;
  let onGround = false;

  // Resolve Y axis first (gravity)
  const resolvedDy = sweepAxis(world, aabb, 1, dy);
  if (Math.abs(resolvedDy - dy) > EPSILON) {
    if (velocity.y < 0) onGround = true;
    velocity.y = 0;
  }
  aabb.translate(0, resolvedDy, 0);

  // Resolve X axis
  const resolvedDx = sweepAxis(world, aabb, 0, dx);
  if (Math.abs(resolvedDx - dx) > EPSILON) {
    velocity.x = 0;
  }
  aabb.translate(resolvedDx, 0, 0);

  // Resolve Z axis
  const resolvedDz = sweepAxis(world, aabb, 2, dz);
  if (Math.abs(resolvedDz - dz) > EPSILON) {
    velocity.z = 0;
  }
  aabb.translate(0, 0, resolvedDz);

  return onGround;
}

function sweepAxis(world, aabb, axis, delta) {
  if (Math.abs(delta) < 0.0001) return 0;

  const minX = Math.floor(axis === 0 ? (delta > 0 ? aabb.getMax(0) : aabb.getMin(0) + delta) : aabb.getMin(0));
  const maxX = Math.floor(axis === 0 ? (delta > 0 ? aabb.getMax(0) + delta : aabb.getMax(0)) : aabb.getMax(0) - EPSILON);
  const minY = Math.floor(axis === 1 ? (delta > 0 ? aabb.getMax(1) : aabb.getMin(1) + delta) : aabb.getMin(1));
  const maxY = Math.floor(axis === 1 ? (delta > 0 ? aabb.getMax(1) + delta : aabb.getMax(1)) : aabb.getMax(1) - EPSILON);
  const minZ = Math.floor(axis === 2 ? (delta > 0 ? aabb.getMax(2) : aabb.getMin(2) + delta) : aabb.getMin(2));
  const maxZ = Math.floor(axis === 2 ? (delta > 0 ? aabb.getMax(2) + delta : aabb.getMax(2)) : aabb.getMax(2) - EPSILON);

  for (let vy = minY; vy <= maxY; vy++) {
    for (let vz = minZ; vz <= maxZ; vz++) {
      for (let vx = minX; vx <= maxX; vx++) {
        const block = world.getBlock(vx, vy, vz);
        // Passable blocks (air, water, wheat) don't collide
        if (isPassable(block)) continue;

        const blockMin0 = axis === 0 ? vx : (axis === 1 ? vy : vz);
        const blockMax0 = blockMin0 + 1;

        if (delta > 0) {
          const allowed = blockMin0 - aabb.getMax(axis);
          if (allowed >= 0 && allowed < delta) {
            delta = Math.max(0, allowed - EPSILON);
          }
        } else {
          const allowed = blockMax0 - aabb.getMin(axis);
          if (allowed <= 0 && allowed > delta) {
            delta = Math.min(0, allowed + EPSILON);
          }
        }
      }
    }
  }

  return delta;
}
